import ViewRefundItems from './ViewRefundItems'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {
  selectViewMigratedOrderItems,
  selectViewOrder,
  selectViewOrderItems,
} from 'app/features/orders/redux/order/orderSlice'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import OrderItemsView from 'app/features/orders/componentsv1/view/OrderItemsView'
import {ViewOrderItems} from 'app/features/orders/componentsv1'
import {useMemo} from 'react'
import {orderFulfillmentStatusTypes, orderStatusType} from 'app/features/orders/models'
import {mapToViewOrderItemsModel} from 'app/features/orders/redux/order/helper'
import {paymentStatusTypes} from 'app/constant'

export const ViewOrderLineItemsWrapper = () => {
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)
  const orderItems = useSelector(selectViewOrderItems)
  const migratedOrderItems = useSelector<RootState, any[]>(selectViewMigratedOrderItems)

  return useMemo(() => {
    if (migratedOrderItems.length > 0 && viewOrder.status === orderStatusType.migration) {
      return <ViewOrderItems items={migratedOrderItems} title='Order Items' />
    } else if (
      viewOrder.fulfillmentStatus === orderFulfillmentStatusTypes.restocked &&
      viewOrder.financialStatus === paymentStatusTypes.paid
    ) {
      return (
        <>
          <ViewOrderItems
            items={mapToViewOrderItemsModel(orderItems, 'quantity')}
            title='Restocked Items'
          />
          <ViewRefundItems order={viewOrder} />
        </>
      )
    }

    return (
      <>
        <OrderItemsView orderItems={orderItems} viewOrder={viewOrder} />
        <ViewRefundItems order={viewOrder} />
      </>
    )
  }, [migratedOrderItems, orderItems, viewOrder])
}

export default ViewOrderLineItemsWrapper
